export default "__VITE_ASSET__7nrP37tH__"